<template>
	<div class="number-box">
		<div class="number"
			:style="{ fontSize: size + 'px', lineHeight: size + 'px', color: color, marginRight: mg + 'px' }"
			v-for="(item, index) in list">{{ item }} </div>
		<div class="unit">{{ unit }}</div>
	</div>
</template>

<script setup>
import { ref, defineProps, defineOptions, onMounted, watch } from 'vue'

defineOptions({
	name: 'Number'
});

const props = defineProps({
	value: 0,
	unit: String,
	size: Number,
	color: '#00E8E8',
	mg: 8,
});

const list = ref([])

const getcount = () => {
	let aa = props.value
	list.value = Array.from(aa)
}

watch(
	() => props.value,
	(val) => {
		list.value = Array.from(val)
	}, {
	immediate: true,
}
)


</script>

<style lang="scss" scoped>
.number-box {
	display: inline-block;
	font-family: 'Pixel LCD7';
	font-weight: 400;
	color: #00E8E8;
	text-align: left;
	display: flex;
	align-items: baseline;
}

.number {
	box-sizing: border-box;
	padding: 8px 6px;
	margin-right: 8px;
	background: #0149A4;
	border-radius: 5px 5px 5px 5px;
	border: 2px solid #00E8E8;
}

.unit {
	font-size: 16px;
	line-height: 19px;
}
</style>